import { apiClient, ENDPOINTS } from '@/lib/api';
import type { Alerta, ResumenDeAlertas } from '../types/alertas.types';

export const alertasService = {
  listar: (
    p: {
      soloNoVistas?: boolean;
      limit?: number;
      storeId?: string;
      antesDe?: string;
      antesDeId?: string;
    } = {}
  ) =>
    apiClient.get<Alerta[]>(ENDPOINTS.ALERTAS, {
      params: {
        soloNoVistas: p.soloNoVistas ? 'true' : undefined,
        limit: p.limit,
        storeId: p.storeId,
        antesDe: p.antesDe,
        antesDeId: p.antesDeId,
      },
    }),
  resumen: () => apiClient.get<ResumenDeAlertas>(ENDPOINTS.ALERTAS_RESUMEN),
  marcarVista: (id: string) => apiClient.post<{ marcada: boolean }>(ENDPOINTS.ALERTAS_VISTA(id)),
  marcarTodas: (hasta: string) =>
    apiClient.post<{ marcadas: number }>(ENDPOINTS.ALERTAS_VISTAS, { hasta }),
};
